// PRCTASection.js - New Zealand
import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MessageCircle, FileText } from 'lucide-react';
import { CALENDLY_PR_NEW_ZEALAND } from '../../../constants';

const PRCTASection = () => {
  const handleBookConsultation = () => {
    if (CALENDLY_PR_NEW_ZEALAND) {
      window.open(CALENDLY_PR_NEW_ZEALAND, '_blank', 'noopener,noreferrer');
    }
  };

  const ctaOptions = [
    {
      icon: Calendar,
      title: 'Talk It Through',
      description: 'Set up a free call about your New Zealand residence options and your eligibility',
      action: 'Book a Time',
      onClick: handleBookConsultation
    },
    {
      icon: MessageCircle,
      title: 'Ask a Question',
      description: 'Write to the team and we will come back to you with an answer',
      action: 'Contact the Team',
      link: '/contact'
    },
    {
      icon: FileText,
      title: 'See What It Costs',
      description: 'Review our fees for residence application support',
      action: 'View Fees',
      link: '/pricing'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-primary to-secondary">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            Thinking of Making the Move to New Zealand?
          </h2>
          <p className="text-white/90 text-base font-light max-w-2xl mx-auto mb-8">
            We have taken applicants through New Zealand residence applications before, and yours will get the same attention.
          </p>
          <button
            onClick={handleBookConsultation}
            className="bg-white hover:bg-gray-100 text-primary font-normal text-base px-8 py-4 rounded-lg transition-colors inline-flex items-center gap-2"
          >
            <Calendar size={20} />
            Arrange Your Free Consultation
          </button>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {ctaOptions.map((option, index) => {
            const Icon = option.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors"
              >
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-4">
                  <Icon size={24} className="text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {option.title}
                </h3>
                <p className="text-white/80 text-sm font-light leading-relaxed mb-4">
                  {option.description}
                </p>
                {option.onClick ? (
                  <button
                    onClick={option.onClick}
                    className="text-white text-sm font-normal hover:underline"
                  >
                    {option.action} →
                  </button>
                ) : (
                  <a
                    href={option.link}
                    className="text-white text-sm font-normal hover:underline"
                  >
                    {option.action} →
                  </a>
                )}
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-12 grid md:grid-cols-3 gap-6 text-center"
        >
          <div className="text-white">
            <p className="text-3xl font-semibold mb-2">1:1</p>
            <p className="text-white/80 text-sm font-light">Eligibility Review First</p>
          </div>
          <div className="text-white">
            <p className="text-3xl font-semibold mb-2">2014</p>
            <p className="text-white/80 text-sm font-light">Registered in England &amp; Wales Since</p>
          </div>
          <div className="text-white">
            <p className="text-3xl font-semibold mb-2">8-18</p>
            <p className="text-white/80 text-sm font-light">Months, Usual Timeline</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PRCTASection;
